module.exports = __webpack_public_path__ + "assets/img/f4.db1f93cc.jpg";